import { render, staticRenderFns } from "./DocumentName.vue?vue&type=template&id=5cb502f0&scoped=true&"
import script from "./DocumentName.vue?vue&type=script&lang=js&"
export * from "./DocumentName.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_name.scss?vue&type=style&index=0&id=5cb502f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb502f0",
  null
  
)

export default component.exports